import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress as MuiCircularProgress, } from '@mui/material';
import { styled } from '../../utils';
const FilledWrapper = styled('div')({
    position: 'relative',
});
const FilledBGProgress = styled(MuiCircularProgress)(({ theme }) => ({
    color: theme.palette.groupPrimary.lightBlue,
}));
const FilledProgress = styled(MuiCircularProgress)({
    position: 'absolute',
    left: 0,
});
const CircularProgressWrapper = styled('div')({
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
});
export const CircularProgress = ({ filled, ...props }) => filled ? (_jsxs(FilledWrapper, { children: [_jsx(FilledBGProgress, { ...props, variant: "determinate", value: 100 }), _jsx(FilledProgress, { ...props, variant: "indeterminate", disableShrink: true })] })) : (_jsx(MuiCircularProgress, { ...props }));
export const CircularProgressContainer = () => (_jsx(CircularProgressWrapper, { children: _jsx(MuiCircularProgress, {}) }));
